import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import { ContainerLabel } from "../GeneralMap.styled";
import { autoSearchInputStyles } from "@utils/extra-style";

const SupplierFilter = (props) => {
  const { t, selectedSupplier, setSelectedSupplier, countryIdList, countryId } =
    props;

  const [resultList, setResultList] = useState([]);
  const [isEntitySuggestionsLoading, setEntitySuggestionsLoading] =
    useState(false);

  useEffect(() => {
    let countryInfo = countryId;
    if (countryIdList?.length > 0) {
      countryInfo = countryIdList;
    }
    const url = `/general/search?search=&limit=20&countries=[${countryInfo}]&objectTypes=["supplier"]&orderBy=asc`;
    getEntityData(url, "selectedDefault");
  }, [countryIdList]);

  const searchEntity = (e) => {
    const search = e.target.value;
    if (search.length >= 3) {
      let countryInfo = countryId;
      if (countryIdList?.length > 0) {
        countryInfo = countryIdList;
      }
      let url = `/general/search?search=${search}&limit=100&countries=[${countryInfo}]&objectTypes=["supplier"]&orderBy=asc`;
      getEntityData(url, "all");
    }
  };
  const getEntityData = (url, type) => {
    setEntitySuggestionsLoading(true);
    axios
      .get(url)
      .then((response) => {
        let entityGroupList = [];
        if (response?.data?.companies) {
          response.data.companies.map((key) => {
            entityGroupList.push({
              name: key.id + " - " + key.name,
              id: key.id,
            });
          });
          setResultList(entityGroupList);
          setEntitySuggestionsLoading(false);
          if (
            type === "selectedDefault" &&
            response.data.companies.length === 1
          ) {
            setSelectedSupplier(entityGroupList[0]);
          }
        }
      })
      .catch((error) => {
        if (window.debugMode) {
          console.error(
            "Error: an error occurred while fetching entities",
            error
          );
        }
        setResultList([]);
        setEntitySuggestionsLoading(false);
      });
  };

  return (
    <>
      <ContainerLabel>
        {" "}
        {t("MAP_FILTER_SUPPLIERS")}
        {isEntitySuggestionsLoading && (
          <ClipLoader size={15} background="#15aee5 !important" />
        )}
      </ContainerLabel>
      <Autocomplete
        multiple
        id="tags-outlined"
        options={resultList}
        disablePortal
        getOptionLabel={(option) => option.name || " "}
        // style={{ zIndex: 99999999999 }}
        sx={{
          backgroundColor: "white", // Sets background for the entire Autocomplete area
          "& .MuiOutlinedInput-root": {
            backgroundColor: "white", // Sets background specifically for the input field
          },
        }}
        filterSelectedOptions
        renderOption={(props, option) => (
          <Box component="li" {...props} key={option.id}>
            {option.name}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder=""
            size="small"
            style={autoSearchInputStyles}
          />
        )}
        value={selectedSupplier}
        onKeyUp={searchEntity}
        onChange={(event, newValue) => {
          setSelectedSupplier(newValue);
        }}
        // Add These props
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterOptions={(options, params) => {
          const filtered = createFilterOptions()(options, params);
          return [...filtered];
        }}
      />
    </>
  );
};

SupplierFilter.propTypes = {
  t: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  objectId: PropTypes.number,
};

SupplierFilter.defaultProps = {
  isEditMode: false,
  objectId: null,
};
export default withTranslation()(SupplierFilter);
